export class DataCatalogMaskingPolicyBody {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "transform",
            "baseName": "transform",
            "type": "DataCatalogMaskTransform",
            "format": ""
        },
        {
            "name": "column",
            "baseName": "column",
            "type": "string",
            "format": ""
        },
        {
            "name": "columnType",
            "baseName": "columnType",
            "type": "DataCatalogColumnType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogMaskingPolicyBody.attributeTypeMap;
    }
    constructor() {
    }
}
